import React from 'react';
import '../styles/StocktagBrandLogo.css';

const StocktagBrandLogo = ({
  variant = 'full',
  className = '',
  label = 'Stocktag.AI',
  decorative = false
}) => {
  const normalizedVariant = variant === 'icon' ? 'icon' : 'full';

  return (
    <span
      className={`stocktag-brand-logo stocktag-brand-logo--${normalizedVariant} ${className}`.trim()}
      role={decorative ? undefined : 'img'}
      aria-label={decorative ? undefined : label}
      aria-hidden={decorative ? 'true' : undefined}
    />
  );
};

export default StocktagBrandLogo;
